import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { BookingService } from "../../services/bookings.service";
import BookingTable from "../../components/bookings/BookingTable";
import AssignEmployeeModal from "../../components/bookings/AssignEmployeeModal";
import Loader from "../../components/common/Loader";
import EmptyState from "../../components/common/EmptyState";
import { useNavigate } from "react-router-dom";

const BookingManagementPage = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const navigate = useNavigate();

  const fetchBookings = async () => {
    setLoading(true);
    try {
      const data = await BookingService.listBookings();
      setBookings(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const handleAction = async (action, booking) => {
    if (action === 'edit') {
        navigate(`/admin/booking-management/edit/${booking.id}`);
    } else if (action === 'view') {
        navigate(`/admin/booking-management/edit/${booking.id}`); // View is essentially Edit mode or Read-only on same page
    } else if (action === 'assign') {
        setSelectedBooking(booking);
        setAssignModalOpen(true);
    } else if (action === 'confirm') {
        await BookingService.setBookingStatus(booking.id, 'confirmed');
        fetchBookings();
    } else if (action === 'cancel') {
        if (window.confirm("Are you sure you want to cancel this booking?")) {
            await BookingService.setBookingStatus(booking.id, 'cancelled');
            fetchBookings();
        }
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>Booking Management</Typography>
      
      {loading ? (
        <Loader />
      ) : bookings.length === 0 ? (
        <EmptyState message="No bookings found" />
      ) : (
        <BookingTable bookings={bookings} onAction={handleAction} />
      )}

      {selectedBooking && (
          <AssignEmployeeModal 
            open={assignModalOpen}
            booking={selectedBooking}
            onClose={() => setAssignModalOpen(false)}
            onAssignSuccess={() => {
                fetchBookings();
            }}
          />
      )}
    </Box>
  );
};

export default BookingManagementPage;
